module.exports = __webpack_public_path__ + "img/20191220152250360截图20191220145648800.32db7e69.jpg";